import { type ExpenseCategorySlug } from '../domain/expenseCategories';
import type { ExpenseSettlementRow } from '../domain/expenseTypes';

/**
 * Normaliza la fecha de pago a ISO.
 * cash_drawer siempre paga "ahora" (la plata sale de la caja de este turno);
 * el resto acepta YYYY-MM-DD (se fija al mediodía UTC para evitar corrimientos
 * de día por zona horaria) o un ISO completo.
 */
export function normalizePaidAt(
  method: ExpenseSettlementRow['method'],
  paidAt: string | null | undefined
): string {
  if (method === 'cash_drawer') return new Date().toISOString();
  const trimmed = paidAt?.trim() || '';
  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
    return `${trimmed}T12:00:00.000Z`;
  }
  return trimmed || new Date().toISOString();
}

/** Resultado de registrar un pago — lo produce el intake server-authoritative. */
export type SettleExpenseResult = {
  settlementId: string;
  expenseId: string;
  branchId: string;
  method: ExpenseSettlementRow['method'];
  amount: number;
  categorySlug: ExpenseCategorySlug;
  cashSessionId: string | null;
  cashOutflowId: string | null;
  note: string | null;
  paidAt: string;
  createdBy: string | null;
};
